import React from "react";
import { Link } from "react-router-dom";

const CallToAction = () => {
  //============== main_return_function =================//
  return (
    <section
      id="call-to-action"
      className="call-to-action font-[poppins] section"
    >
      <div className="container" data-aos="zoom-out">
        <div className="row g-5">
          <div className="col-lg-8 col-md-6 content d-flex flex-column justify-content-center order-last order-md-first">
            <h3 className=" !text-[37px] font-[poppins]">
              Transform Your Business with Oethical’s
              <span className="font-[Playfair] italic text-[#9bd66c]">
                {" "}
                Cutting-Edge IT Solutions
              </span>
            </h3>
            <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>
            <p className="lead">
              At Oethical Technology, we deliver smart, customized IT services
              and products that power your business forward. Whether you need
              strategic solutions or scalable technologies, we’re here to help
              you grow faster, work smarter, and achieve long-term success.
            </p>
            <Link className="cta-btn align-self-start" to="/contactUs">
              Get In Touch
            </Link>
          </div>
          <div className="col-lg-4 col-md-6 order-first order-md-last d-flex align-items-center">
            <div className="img">
              <img
                src={
                  process.env.PUBLIC_URL + "/assets/img/in-the-office_ma2b.svg"
                }
                alt="Contact Us"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
